import React, { CSSProperties } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import GoogleDeliveryMap from 'src/delivery/components/google-delivery-map';
import MapboxDeliveryMap from 'src/delivery/components/mapbox-delivery-map';

const DELIVERY_MAPBOX_FLAG = 'growth.ecomm.delivery-tracking-mapbox.rollout';

type DeliveryMapFlags = Partial<Record<typeof DELIVERY_MAPBOX_FLAG, unknown>>;

export type DeliveryMapProps = {
  initialCenter: Readonly<{
    lat?: number | null;
    lng?: number | null;
  }>;
  width: CSSProperties['width'];
  height: CSSProperties['height'];
  tag: string | null | undefined;
};

// ECOMM-13538: Google -> Mapbox migration, gated behind growth.ecomm.delivery-tracking-mapbox.rollout
// (default off). ECOMM-13539 removes this dispatcher + the Google branch once rolled out.
export default function GMap(props: DeliveryMapProps): JSX.Element {
  const flags = useFlags<DeliveryMapFlags>();
  const useMapbox = flags[DELIVERY_MAPBOX_FLAG] === true;

  if (useMapbox) {
    return <MapboxDeliveryMap {...props} />;
  }
  return <GoogleDeliveryMap {...props} />;
}
